import { render, staticRenderFns } from "./SystemConfig.vue?vue&type=template&id=2012201a&scoped=true"
import script from "./SystemConfig.vue?vue&type=script&lang=js"
export * from "./SystemConfig.vue?vue&type=script&lang=js"
import style0 from "./SystemConfig.vue?vue&type=style&index=0&id=2012201a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2012201a",
  null
  
)

export default component.exports